import { commonConstants, appConstants, alertConstants } from '../_constants';
import { commonService } from '../_services';
import { appHelpers } from "../_helpers";
// import {alertActions} from "./index";
// import {apiActions} from "./api.actions";

function getAllAirlines() {
    return dispatch => {
        return commonService.getAllAirlines()
            .then(response => {
                if (response.error == null) {
                    dispatch(success(response.data));
                } else {
                    dispatch(failure(response));
                }
            },
                error => {
                    let errorMessage = (error.response.data) ? error.response.data : 'Unable to handle request';
                    dispatch(failure(errorMessage));
                }
            );
    };

    function success(airlines) { return { type: commonConstants.AIRLINES_SUCCESS, airlines } }
    function failure(message) { return { type: appConstants.REQUEST_FAILURE, message } }
}
function getAirlinesCarriers() {
    return dispatch => {
        return commonService.getAirlinesCarriers()
            .then(response => {
                if (response.error == null) {
                    dispatch(success(response.data));
                } else {
                    dispatch(failure(response));
                }
            },
                error => {
                    let errorMessage = (error.response.data) ? error.response.data : 'Unable to handle request';
                    dispatch(failure(errorMessage));
                }
            );
    };

    function success(airlinesCarriers) { return { type: commonConstants.AIRLINES_CARRIERS_SUCCESS, airlinesCarriers } }
    function failure(message) { return { type: appConstants.REQUEST_FAILURE, message } }
}

function getDesAirports() {
    return dispatch => {

        return commonService.getAllAirports()
            .then(
                response => {
                    if (response.error == null) {
                        dispatch(success(response.data));
                    } else {
                        dispatch(failure(response));
                    }
                },
                error => {
                    let errorMessage = (error.response.data) ? error.response.data : 'Unable to handle request';
                    dispatch(failure(errorMessage));
                }
            );
    };

    function success(desAirports) { return { type: commonConstants.DES_AIRPORTS_SUCCESS, desAirports } }
    function failure(message) { return { type: appConstants.REQUEST_FAILURE, message } }
}

function getDepAirports() {
    return dispatch => {

        return commonService.getAllAirports()
            .then(
                response => {
                    if (response.error == null) {
                        dispatch(success(response.data));
                    } else {
                        dispatch(failure(response));
                    }
                },
                error => {
                    let errorMessage = (error.response.data) ? error.response.data : 'Unable to handle request';
                    dispatch(failure(errorMessage));
                }
            );
    };

    function success(depAirports) { return { type: commonConstants.DEP_AIRPORTS_SUCCESS, depAirports } }
    function failure(message) { return { type: appConstants.REQUEST_FAILURE, message } }
}

function getAllCountries() {
    return dispatch => {

        return commonService.getAllCountries()
            .then(
                response => {
                    if (response.error == null) {
                        dispatch(success(response.data));
                    } else {
                        dispatch(failure(response));
                    }
                },
                error => {
                    let errorMessage = (error.response.data) ? error.response.data : 'Unable to handle request';
                    dispatch(failure(errorMessage));
                }
            );
    };

    function success(countries) { return { type: commonConstants.COUNTRIES_SUCCESS, countries } }
    function failure(message) { return { type: appConstants.REQUEST_FAILURE, message } }
}

function getAllFlightDays() {
    return dispatch => {

        return commonService.getFlightDays()
            .then(
                response => {
                    if (response.error == null) {
                        dispatch(success(response.data));
                    } else {
                        dispatch(failure(response));
                    }
                },
                error => {
                    let errorMessage = (error.response.data) ? error.response.data : 'Unable to handle request';
                    dispatch(failure(errorMessage));
                }
            );
    };

    function success(flightDays) { return { type: commonConstants.FLIGHT_DAYS_SUCCESS, flightDays } }
    function failure(message) { return { type: appConstants.REQUEST_FAILURE, message } }
}

function getDashboardReport(payload) {
    return dispatch => {
        return commonService.getDashboardReport(payload)
            .then(
                response => {
                    if (response.error == null) {
                        dispatch(success(response.data));
                    } else {
                        dispatch(failure(response));
                    }
                },
                error => {
                    let errorMessage = appHelpers.interpretErrorResponse(error);
                    dispatch(failure(errorMessage));
                }
            );
    };

    function success(dashboard) { return { type: commonConstants.DASHBOARD_SUCCESS, dashboard } }
    // function failure(message) { return { type: appConstants.REQUEST_FAILURE, message } }
    function failure(message) { return { type: alertConstants.ERROR, message } }
}
function setDashboardFilter(dashboardFilters) {
    return dispatch => {
        dispatch({ type: commonConstants.DASHBOARD_FILTER, dashboardFilters });
    };
}

function manageAirport(payload) {
    return dispatch => {
        return commonService.manageAirport(payload)
            .then(
                res => {
                    if (res.status === appConstants.SUCCESS_RESPONSE) {
                        dispatch(success(res.response));
                    }
                    else if (res.status === appConstants.ERROR_RESPONSE) {
                        dispatch(failure(res.response));
                    }
                    return res;
                }
            )
    };

    function success(response) { return { type: appConstants.REQUEST_SUCCESS, response } }
    function failure(message) { return { type: appConstants.REQUEST_FAILURE, message } }
}

function manageAirline(payload) {
    return dispatch => {
        return commonService.manageAirline(payload)
            .then(
                res => {
                    if (res.status === appConstants.SUCCESS_RESPONSE) {
                        dispatch(success(res.response));
                    }
                    else if (res.status === appConstants.ERROR_RESPONSE) {
                        dispatch(failure(res.response));
                    }
                    return res;
                }
            )
    };

    function success(response) { return { type: appConstants.REQUEST_SUCCESS, response } }
    function failure(message) { return { type: appConstants.REQUEST_FAILURE, message } }
}

function manageFlight(payload) {
    return dispatch => {
        return commonService.manageFlight(payload)
            .then(
                response => {
                    if (response.error == null) {
                        dispatch(success(response));
                    } else {
                        dispatch(failure(response));
                    }
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function success(response) { return { type: appConstants.REQUEST_SUCCESS, response } }
    function failure(message) { return { type: appConstants.REQUEST_FAILURE, message } }
}


function manageFTPCredential(payload) {
    return dispatch => {
        return commonService.manageFTPCredential(payload)
            .then(
                res => {
                    if (res.status === appConstants.SUCCESS_RESPONSE) {
                        dispatch(success(res.response));
                    }
                    else if (res.status === appConstants.ERROR_RESPONSE) {
                        dispatch(failure(res.response));
                    }
                    return res;
                }
            )
    };

    function success(response) { return { type: appConstants.REQUEST_SUCCESS, response } }
    function failure(message) { return { type: appConstants.REQUEST_FAILURE, message } }
}


function getInvoiceReconciliation(payload) {
    return dispatch => {
        return commonService.getInvoiceReconciliation(payload)
            .then(
                response => {
                    if (response.status === appConstants.SUCCESS_RESPONSE) {
                        dispatch(success(response.response));
                    }
                    else if (response.status === appConstants.ERROR_RESPONSE) {
                        dispatch(failure(response.response));
                    }
                },
                error => {
                    let errorMessage = appHelpers.interpretErrorResponse(error);
                    dispatch(failure(errorMessage));
                }
            );
    };

    function success(invoice) { return { type: commonConstants.INVOICE_RECONCILIATION_SUCCESS, invoice } }
    function failure(message) { return { type: alertConstants.ERROR, message } }
}

function getUsersByOrganization(payload) {
    return dispatch => {
        return commonService.getUsersByOrganization(payload)
            .then(
                response => {
                    if (response.status === appConstants.SUCCESS_RESPONSE) {
                        dispatch(success(response.response));
                    }
                    else if (response.status === appConstants.ERROR_RESPONSE) {
                        dispatch(failure(response.response));
                    }
                },
                error => {
                    let errorMessage = appHelpers.interpretErrorResponse(error);
                    dispatch(failure(errorMessage));
                }
            );
    };

    function success(users) { return { type: commonConstants.USERS_SUCCESS, users } }
    function failure(message) { return { type: alertConstants.ERROR, message } }
}
function getWorkflowProcess() {
    return dispatch => {
        return commonService.getWorkFlowProcess()
            .then(
                response => {
                    if (response.status === appConstants.SUCCESS_RESPONSE) {
                        dispatch(success(response.response));
                    }
                    else if (response.status === appConstants.ERROR_RESPONSE) {
                        dispatch(failure(response.response));
                    }
                },
                error => {
                    let errorMessage = appHelpers.interpretErrorResponse(error);
                    dispatch(failure(errorMessage));
                }
            );
    };

    function success(workFlowProcess) { return { type: commonConstants.WORKFLOW_PROCESS_SUCCESS, workFlowProcess } }
    function failure(message) { return { type: alertConstants.ERROR, message } }
}
function getIATAValidation(payload) {
    return dispatch => {
        return commonService.getIATAValidation(payload)
            .then(
                response => {
                    if (response.status === appConstants.SUCCESS_RESPONSE) {
                        dispatch(success(response.response));
                    }
                    else if (response.status === appConstants.ERROR_RESPONSE) {
                        dispatch(failure(response.response));
                    }
                },
                error => {
                    let errorMessage = appHelpers.interpretErrorResponse(error);
                    dispatch(failure(errorMessage));
                }
            );
    };

    function success(IATAValidation) { return { type: commonConstants.IATA_VALIDATION_SUCCESS, IATAValidation } }
    function failure(message) { return { type: alertConstants.ERROR, message } }
}

function getEntities() {
    return dispatch => {
        return commonService.searchAppEntityTypes(appConstants.MAKER_CHECKER_APP_ID)
            .then(
                response => {
                    if (response.status === appConstants.SUCCESS_RESPONSE) {
                        dispatch(success(response.response.Results));
                    }
                    else if (response.status === appConstants.ERROR_RESPONSE) {
                        dispatch(failure(response.response));
                    }
                },
                error => {
                    let errorMessage = appHelpers.interpretErrorResponse(error);
                    dispatch(failure(errorMessage));
                }
            );
    };

    function success(entities) { return { type: commonConstants.GET_ENTITIES, entities } }
    function failure(message) { return { type: alertConstants.ERROR, message } }
}

function searchAirlineLocations(payload) {
    return dispatch => {
        return commonService.searchAirlineLocations(payload)
            .then(
                response => {
                    if (response.status === appConstants.SUCCESS_RESPONSE) {
                        dispatch(success(response.response));
                    }
                    else if (response.status === appConstants.ERROR_RESPONSE) {
                        dispatch(failure(response.response));
                    }
                },
                error => {
                    let errorMessage = appHelpers.interpretErrorResponse(error);
                    dispatch(failure(errorMessage));
                }
            );
    };
    function success(airlineLocations) { return { type: commonConstants.GET_AIRLINE_LOCATIONS, airlineLocations } }
    function failure(message) { return { type: alertConstants.ERROR, message } }
}

function getFlagMetrics() {
    return dispatch => {
        return commonService.getFlagMetrics()
            .then(
                response => {
                    if (response.status === appConstants.SUCCESS_RESPONSE) {
                        dispatch(success(response.response));
                    }
                    else if (response.status === appConstants.ERROR_RESPONSE) {
                        dispatch(failure(response.response));
                    }
                },
                error => {
                    let errorMessage = appHelpers.interpretErrorResponse(error);
                    dispatch(failure(errorMessage));
                }
            );
    };

    function success(flagMetrics) { return { type: commonConstants.GET_FLAG_METRICS, flagMetrics } }
    function failure(message) { return { type: alertConstants.ERROR, message } }
}

function getTicketClass() {
    return dispatch => {
        return commonService.getTicketClass()
            .then(
                response => {
                    if (response.status === appConstants.SUCCESS_RESPONSE) {
                        dispatch(success(response.response));
                    }
                    else if (response.status === appConstants.ERROR_RESPONSE) {
                        dispatch(failure(response.response));
                    }
                },
                error => {
                    let errorMessage = appHelpers.interpretErrorResponse(error);
                    dispatch(failure(errorMessage));
                }
            );
    };

    function success(ticketClass) { return { type: commonConstants.GET_TICKET_CLASS, ticketClass } }
    function failure(message) { return { type: alertConstants.ERROR, message } }
}

function getTicketCategory() {
    return dispatch => {
        return commonService.getTicketCategory()
            .then(
                response => {
                    if (response.status === appConstants.SUCCESS_RESPONSE) {
                        dispatch(success(response.response));
                    }
                    else if (response.status === appConstants.ERROR_RESPONSE) {
                        dispatch(failure(response.response));
                    }
                },
                error => {
                    let errorMessage = appHelpers.interpretErrorResponse(error);
                    dispatch(failure(errorMessage));
                }
            );
    };

    function success(ticketCategory) { return { type: commonConstants.GET_TICKET_CATEGORY, ticketCategory } }
    function failure(message) { return { type: alertConstants.ERROR, message } }
}

export const commonActions = {
    getIATAValidation,
    getAllAirlines,
    getAirlinesCarriers,
    getDesAirports,
    getDepAirports,
    getAllCountries,
    getAllFlightDays,
    manageFlight,
    manageAirport,
    manageAirline,
    getDashboardReport,
    setDashboardFilter,
    manageFTPCredential,
    getInvoiceReconciliation,
    getUsersByOrganization,
    getWorkflowProcess,
    getEntities,
    searchAirlineLocations,
    getFlagMetrics,
    getTicketClass,
    getTicketCategory
};



// WEBPACK FOOTER //
// ./src/_actions/common.actions.js